import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetNestedProductCategoriesQuery } from 'features/nested-product-category/services';
import { useGetPlacesQuery } from 'features/place/services';
import { useWorkspace } from 'hooks/useWorkspace';
import { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { mapToSelectOptions } from 'utils/filter-select-helpers';
import { configureTableColumns } from 'utils/table-helpers';
import { NestedProductColumns, useNestedPorductTableColumns } from '../constants/table-settings';
import useTable from 'hooks/useTable';

const useController = () => {
    const { placeId = '' } = useParams();
    const [activePlace, setActivePlace] = useState<string>(placeId);
    const { websiteId } = useWorkspace();
    const navigate = useNavigate();

    const { data: places } = useGetPlacesQuery({
        ...FETCH_ALL_PARAMS,
        website_id: websiteId,
    });
    const { data: nestedProductCategories } = useGetNestedProductCategoriesQuery(FETCH_ALL_PARAMS);

    const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
        setActivePlace(newValue);
        navigate(`../nestedProducts/${newValue}`);
    };

    const handleAddNestedProduct = () => {
        navigate('add/nestedProduct/');
    };

    const filterSelectOptions = useMemo(() => {
        if (!nestedProductCategories) return {};

        return {
            nestedProductCategoryName: mapToSelectOptions(nestedProductCategories.content),
        };
    }, [nestedProductCategories]);

    const { tableSettings } = useTable<NestedProductColumns>({
        columns: configureTableColumns(useNestedPorductTableColumns(), filterSelectOptions),
        queryIdentifier: 'nestedProducts',
        renderAddButton: false,
    });

    return {
        tableSettings,
        websiteId,
        places,
        placeId,
        activePlace,
        handleTabChange,
        handleAddNestedProduct,
    };
};
export default useController;
